import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const skeletonVariants = cva(styles.skeleton, {
  variants: {
    display: {
      inline: styles.inline,
      block: styles.block,
    },
    radius: {
      none: styles.radiusNone,
      xs: styles.radiusXs,
      sm: styles.radiusSm,
      md: styles.radiusMd,
      lg: styles.radiusLg,
      xl: styles.radiusXl,
      '2xl': styles.radius2xl,
      '3xl': styles.radius3xl,
      full: styles.radiusFull,
    },
  },
  defaultVariants: {
    display: 'inline',
    radius: 'lg',
  },
});
